<script>
/**
 * @file icon 组件
 */
export default {
    name: 'forkiss-icon',
    props: {
        icon: {
            type: String
        },
        showLabel: {
            type: Boolean,
            default: true
        }
    }
}
</script>

<template lang="pug">
.forkiss-icon-box
    i.forkiss-icon(:class="icon")
    label.forkiss-icon-label(v-if="showLabel")
        slot
</template>

<style lang="less">
.forkiss-icon-box {
    position: relative;

    .forkiss-icon {
        display: inline-block;
        vertical-align: middle;
        width: .24rem;
        height: .24rem;
        background-repeat: no-repeat;
        background-size: contain;
        background-position: center;

        &.forkiss-icon-time {
            background-image: url(../assets/time-icon.svg);
        }

        &.forkiss-icon-time-white {
            background-image: url(../assets/teacher/time-icon.svg);
        }

        &.forkiss-icon-address {
            height: .25rem;
            background-image: url(../assets/address-icon.svg);
        }

        &.forkiss-icon-address-white {
            height: .25rem;
            background-image: url(../assets/teacher/address-icon.svg);
        }

        &.forkiss-icon-question {
            width: .25rem;
            height: .25rem;
            background-image: url(../assets/question.png);
        }


        &.forkiss-icon-question-white {
            width: .25rem;
            height: .25rem;
            background-image: url(../assets/question-white.png);
        }
        &.forkiss-icon-points {
            width: .34rem;
            height: .34rem;
            background-image: url(../assets/points.png);
        }

        &.forkiss-icon-home {
            width: .42rem;
            height: .42rem;
            background-image: url(../assets/home-icon.svg);

            &.active {
                background-image: url(../assets/home-icon-active.svg);
            }
        }

        &.forkiss-icon-classes {
            width: .42rem;
            height: .42rem;
            background-image: url(../assets/classes-icon.svg);

            &.active {
                background-image: url(../assets/classes-icon-active.svg);
            }
        }

        &.forkiss-icon-order {
            width: .42rem;
            height: .42rem;
            background-image: url(../assets/order-icon.svg);

            &.active {
                background-image: url(../assets/order-icon-active.svg);
            }
        }

        &.forkiss-icon-center {
            width: .42rem;
            height: .42rem;
            background-image: url(../assets/center-icon.svg);

            &.active {
                background-image: url(../assets/center-icon-active.svg);
            }
        }
    }

    .forkiss-icon-label {
        display: inline-block;
        vertical-align: middle;
        font-size: .24rem;
        margin-left: .15rem;

    }
}
</style>


// WEBPACK FOOTER //
// src/components/forkiss-icon.vue